// AUTO-GENERATED by codegen.ts from the OpenAPI spec + agent-tool-manifest snapshot. Do not edit.
import type { AgentToolDescriptor } from "../common/agent/agentTypes";

export const agentToolCatalog: AgentToolDescriptor[] = [
  {
    "toolName": "listCombinedEventsForBuyer",
    "method": "GET",
    "riskTier": "none",
    "description": "Lister anskaffelser med status og frister",
    "params": [
      {
        "name": "statuses",
        "in": "query",
        "required": false,
        "description": "Filtrer på status. PascalCase-verdier gjelder eldre (V1) anskaffelser, SCREAMING_SNAKE gjelder V2 — ta med begge varianter for å dekke begge (f.eks. Published og PUBLISHED).",
        "schema": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "Draft",
              "Published",
              "Completed",
              "Awarded",
              "Cancelled",
              "Closed",
              "DRAFT",
              "PUBLICATION_PENDING",
              "PUBLISHED",
              "PUBLICATION_FAILED",
              "EVALUATION",
              "AWARD_DECISION",
              "AWARDED",
              "CANCELLED",
              "CLOSED",
              "COMPLETED"
            ]
          }
        }
      },
      {
        "name": "projectIds",
        "in": "query",
        "required": false,
        "description": "Filtrer på tilknyttet prosjekt. Gjelder både eldre (V1) og V2-anskaffelser.",
        "schema": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      {
        "name": "name",
        "in": "query",
        "required": false,
        "description": "Filtrer på navn (delstreng)",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "responsiblePersons",
        "in": "query",
        "required": false,
        "schema": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      {
        "name": "contractTypes",
        "in": "query",
        "required": false,
        "description": "Filtrer på kontraktstype (kun V2-anskaffelser har denne).",
        "schema": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "WORKS",
              "SUPPLIES",
              "SERVICES",
              "COMBINED"
            ]
          }
        }
      },
      {
        "name": "deadlinePassed",
        "in": "query",
        "required": false,
        "description": "Bare anskaffelser der fristen allerede har gått ut.",
        "schema": {
          "type": "boolean"
        }
      },
      {
        "name": "limit",
        "in": "query",
        "required": false,
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "skip",
        "in": "query",
        "required": false,
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "sortBy",
        "in": "query",
        "required": false,
        "schema": {
          "type": "string",
          "enum": [
            "TITLE",
            "REFERENCE_NUMBER",
            "DEADLINE",
            "CREATED_AT",
            "MODIFIED_AT"
          ]
        }
      },
      {
        "name": "sortDirection",
        "in": "query",
        "required": false,
        "schema": {
          "type": "string",
          "enum": [
            "ASC",
            "DESC"
          ]
        }
      }
    ]
  },
  {
    "toolName": "getSourcingEvent",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter detaljer og konfigurasjon for én anskaffelse.",
    "appliesToKind": "V2",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "getBasicSourcingEvent",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter en eldre (grunnleggende) anskaffelse med dens data, spørsmål og status.",
    "appliesToKind": "V1",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "getSourcingEventReadiness",
    "method": "GET",
    "riskTier": "none",
    "description": "Sjekker hva som mangler før en anskaffelse kan publiseres.",
    "appliesToKind": "V2",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "getEvaluation",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter innkomne tilbud med poeng og rangering.",
    "appliesToKind": "V2",
    "params": [
      {
        "name": "round",
        "in": "query",
        "required": false,
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "getBuyerSeV2Questions",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter spørsmål fra leverandører (Q&A).",
    "appliesToKind": "V2",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "getBuyerSupplierInformation",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter informasjon publisert til leverandører.",
    "appliesToKind": "V2",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "getAwardLetters",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter tildelingsbrev (utkast, godkjent, sendt).",
    "appliesToKind": "V2",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "listContractReports",
    "method": "GET",
    "riskTier": "none",
    "description": "Lister kontrakter",
    "entityKind": "contract",
    "params": [
      {
        "name": "titleFilter",
        "in": "query",
        "schema": {
          "type": "string"
        },
        "required": false,
        "description": "Filtrer kontrakter på navn (delstreng, ufølsom for store/små bokstaver)"
      },
      {
        "name": "limit",
        "in": "query",
        "schema": {
          "type": "integer"
        },
        "required": false
      },
      {
        "name": "skip",
        "in": "query",
        "schema": {
          "type": "integer"
        },
        "required": false,
        "description": "Antall kontrakter å hoppe over — bruk sammen med limit for å hente neste side"
      }
    ]
  },
  {
    "toolName": "getContract",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter detaljer for én kontrakt.",
    "entityKind": "contract",
    "params": [
      {
        "name": "contractId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "listContractMessages",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter meldinger (dialog) på en kontrakt.",
    "params": [
      {
        "name": "contractId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "getMe",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter den innloggede brukeren (navn, roller, organisasjoner).",
    "entityKind": "me",
    "params": []
  },
  {
    "toolName": "getProjects",
    "method": "GET",
    "riskTier": "none",
    "description": "Lister prosjekter (kan filtreres på navn).",
    "entityKind": "project",
    "params": [
      {
        "name": "name",
        "in": "query",
        "required": false,
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "status",
        "in": "query",
        "required": false,
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "limit",
        "in": "query",
        "required": false,
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "skip",
        "in": "query",
        "required": false,
        "schema": {
          "type": "integer"
        }
      }
    ]
  },
  {
    "toolName": "getProject",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter detaljer for ett prosjekt.",
    "entityKind": "project",
    "params": [
      {
        "name": "projectId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "listNeeds",
    "method": "GET",
    "riskTier": "none",
    "description": "Lister behov (meld inn behov).",
    "entityKind": "need",
    "params": [
      {
        "name": "status",
        "in": "query",
        "required": false,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "getNeed",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter detaljer for ett behov.",
    "entityKind": "need",
    "params": [
      {
        "name": "needId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "listReceivedBids",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter innkomne tilbud på en V1-anskaffelse.",
    "appliesToKind": "V1",
    "params": [
      {
        "name": "negotiationRound",
        "in": "query",
        "required": false,
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "listMyNotifications",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter dine varsler.",
    "entityKind": "notification",
    "params": [
      {
        "name": "limit",
        "in": "query",
        "required": false,
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "offset",
        "in": "query",
        "required": false,
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "unseen",
        "in": "query",
        "required": false,
        "schema": {
          "type": "boolean"
        }
      },
      {
        "name": "unread",
        "in": "query",
        "required": false,
        "description": "Bare uleste varsler. I motsetning til unseen tømmes ikke dette av å åpne varsellisten.",
        "schema": {
          "type": "boolean"
        }
      }
    ]
  },
  {
    "toolName": "answerSeV2Question",
    "method": "PATCH",
    "riskTier": "reversible",
    "description": "Svarer på et spørsmål fra en leverandør (privat svar).",
    "appliesToKind": "V2",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "questionId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "seV2QuestionPatchDto",
        "in": "body",
        "required": true,
        "schema": {
          "type": "object",
          "properties": {
            "answer": {
              "type": "string"
            },
            "attachments": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "documentId": {
                    "type": "string"
                  },
                  "source": {
                    "type": "string",
                    "enum": [
                      "REQUEST",
                      "OFFER",
                      "UPLOAD"
                    ]
                  }
                },
                "required": [
                  "documentId",
                  "source"
                ],
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      }
    ]
  },
  {
    "toolName": "awardSourcingEvent",
    "method": "POST",
    "riskTier": "binding_statutory",
    "description": "Tildeler anskaffelsen til ett eller flere vinnende tilbud.",
    "appliesToKind": "V2",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "awardSourcingEventRequest",
        "in": "body",
        "required": true,
        "schema": {
          "type": "object",
          "properties": {
            "winningBidIds": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "internalNote": {
              "type": "string",
              "nullable": true
            },
            "eventValue": {
              "allOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": {
                      "type": "number",
                      "nullable": true,
                      "format": "double"
                    },
                    "currency": {
                      "type": "string",
                      "enum": [
                        "NOK",
                        "USD",
                        "EUR",
                        "DKK"
                      ]
                    }
                  },
                  "required": [
                    "currency"
                  ],
                  "additionalProperties": false
                }
              ],
              "nullable": true
            }
          },
          "additionalProperties": false,
          "required": [
            "winningBidIds"
          ]
        }
      }
    ]
  },
  {
    "toolName": "createSourcingEvent",
    "method": "POST",
    "riskTier": "reversible",
    "description": "Oppretter en ny anskaffelse (utkast).",
    "params": [
      {
        "name": "title",
        "in": "body",
        "schema": {
          "type": "string"
        },
        "required": true,
        "description": "Anskaffelsens tittel — bruk tom streng hvis brukeren ikke har oppgitt noen"
      },
      {
        "name": "homeDepartment",
        "in": "body",
        "schema": {
          "type": "string",
          "minLength": 1
        },
        "required": true,
        "description": "NAVNET på avdelingen anskaffelsen skal ligge under (ikke en id). Systemmeldingen lister avdelingene du kan opprette i. Spør brukeren hvis det er flere og brukeren ikke har sagt hvilken."
      }
    ]
  },
  {
    "toolName": "createContract",
    "method": "POST",
    "riskTier": "reversible",
    "description": "Oppretter en ny kontrakt (utkast).",
    "entityKind": "contract",
    "params": [
      {
        "name": "homeDepartment",
        "in": "body",
        "schema": {
          "type": "string",
          "minLength": 1
        },
        "required": false,
        "description": "NAVNET på avdelingen kontrakten skal ligge under (ikke en id). Systemmeldingen lister avdelingene du kan opprette i. Utelat hvis det bare er én; spør brukeren hvis det er flere."
      },
      {
        "name": "title",
        "in": "body",
        "schema": {
          "type": "string",
          "minLength": 1
        },
        "required": true,
        "description": "Kontraktens navn/tittel"
      }
    ]
  },
  {
    "toolName": "updateContract",
    "method": "POST",
    "riskTier": "reversible",
    "description": "Oppdaterer feltene på en kontrakt: navn, motpart (via organisasjonssøk), verdi, start- og sluttdato, beskrivelse, ansvarlig person.",
    "entityKind": "contract",
    "params": [
      {
        "name": "contractId",
        "in": "path",
        "schema": {
          "type": "string",
          "description": "Kontraktens id fra et tidligere verktøyresultat"
        },
        "required": true
      },
      {
        "name": "updateContractRequest",
        "in": "body",
        "required": false,
        "description": "Feltene som skal oppdateres på kontrakten",
        "schema": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string",
              "minLength": 1
            },
            "description": {
              "type": "string",
              "minLength": 1
            },
            "counterparty": {
              "type": "object",
              "description": "Motpart (leverandør, kunde eller annen part)",
              "required": [
                "counterparty"
              ],
              "properties": {
                "counterparty": {
                  "type": "object",
                  "properties": {
                    "organizationId": {
                      "type": "string",
                      "minLength": 1,
                      "description": "Fra organisasjonssøket, når treffet er en registrert Organization"
                    },
                    "organizationEntryId": {
                      "type": "string",
                      "minLength": 1,
                      "description": "Fra organisasjonssøket når treffet er en manuell oppføring (type OrganizationEntry)"
                    }
                  }
                }
              }
            },
            "valueAmount": {
              "type": "object",
              "properties": {
                "amount": {
                  "type": "integer",
                  "description": "Kontraktsverdi i NOK (heltall)"
                }
              }
            },
            "startDate": {
              "type": "object",
              "properties": {
                "date": {
                  "type": "string",
                  "minLength": 1,
                  "description": "ISO-dato, f.eks. 2026-06-15"
                }
              }
            },
            "endDate": {
              "type": "object",
              "required": [
                "hasNoEndDate"
              ],
              "properties": {
                "date": {
                  "type": "string",
                  "minLength": 1
                },
                "hasNoEndDate": {
                  "type": "boolean"
                }
              }
            },
            "internalOwner": {
              "type": "object",
              "required": [
                "personId"
              ],
              "properties": {
                "personId": {
                  "type": "string",
                  "minLength": 1
                }
              }
            }
          }
        }
      }
    ]
  },
  {
    "toolName": "publishContract",
    "method": "PUT",
    "riskTier": "reversible",
    "description": "Publiserer en kontrakt (utkast → publisert). Statusen kan ikke settes tilbake til utkast, men feltene kan fortsatt endres etterpå.",
    "entityKind": "contract",
    "params": [
      {
        "name": "contractId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "searchOrganizationsAndEntries",
    "method": "GET",
    "riskTier": "none",
    "description": "Søker etter organisasjoner etter navn eller organisasjonsnummer, f.eks. for å finne en kontraktsmotpart.",
    "params": [
      {
        "name": "name",
        "in": "query",
        "required": false,
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "organizationNumber",
        "in": "query",
        "required": false,
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "limit",
        "in": "query",
        "required": true,
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "skip",
        "in": "query",
        "required": false,
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "type",
        "in": "query",
        "required": false,
        "schema": {
          "type": "string",
          "enum": [
            "Organization",
            "OrganizationEntry"
          ]
        }
      },
      {
        "name": "excludeLinkedEntries",
        "in": "query",
        "required": false,
        "schema": {
          "type": "boolean"
        }
      }
    ]
  },
  {
    "toolName": "getOrganization",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter profilen til en registrert organisasjon (bruk orgId).",
    "entityKind": "organization",
    "params": [
      {
        "name": "orgId",
        "in": "path",
        "schema": {
          "type": "string",
          "minLength": 1
        },
        "required": true,
        "description": "Id-en til organisasjonen som skal hentes (fra sidekonteksten eller organisasjonssøket) — IKKE din egen organisasjons-id"
      }
    ]
  },
  {
    "toolName": "getOrganizationEntry",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter en bedriftsoppføring fra markedsregisteret (bruk entryId).",
    "entityKind": "orgEntry",
    "params": [
      {
        "name": "entryId",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "searchBrregOrgsByName",
    "method": "GET",
    "riskTier": "none",
    "description": "Søker i Brønnøysundregistrene etter norske selskaper på navn — bruk dette for å finne korrekt navn, organisasjonsnummer og adresse før en ny motpart opprettes.",
    "params": [
      {
        "name": "query",
        "in": "query",
        "required": true,
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "limit",
        "in": "query",
        "required": false,
        "schema": {
          "type": "integer"
        }
      }
    ]
  },
  {
    "toolName": "lookupBrregOrg",
    "method": "GET",
    "riskTier": "none",
    "description": "Slår opp ett selskap i Brønnøysundregistrene på organisasjonsnummer (9 siffer).",
    "params": [
      {
        "name": "organizationNumber",
        "in": "path",
        "required": true,
        "schema": {
          "type": "string"
        }
      }
    ]
  },
  {
    "toolName": "createOrganizationEntry",
    "method": "POST",
    "riskTier": "reversible",
    "description": "Oppretter en bedriftsoppføring i markedsregisteret, f.eks. en ny kontraktsmotpart som ikke finnes i organisasjonssøket. Slå opp selskapet i Brønnøysundregistrene først.",
    "entityKind": "orgEntry",
    "params": [
      {
        "name": "name",
        "in": "body",
        "schema": {
          "type": "string",
          "minLength": 2
        },
        "required": true,
        "description": "Selskapets navn — helst nøyaktig slik Brønnøysund-søket returnerte det"
      },
      {
        "name": "organizationNumber",
        "in": "body",
        "schema": {
          "type": "string",
          "minLength": 9,
          "maxLength": 9
        },
        "required": true,
        "description": "Organisasjonsnummer (9 siffer) fra Brønnøysund-søket"
      },
      {
        "name": "street",
        "in": "body",
        "schema": {
          "type": "string"
        },
        "required": false
      },
      {
        "name": "postCode",
        "in": "body",
        "schema": {
          "type": "string"
        },
        "required": false
      },
      {
        "name": "city",
        "in": "body",
        "schema": {
          "type": "string"
        },
        "required": false
      }
    ]
  }
];
